export default __webpack_public_path__ + "static/media/AT-2020-16-6.e5f1087b.png";